import React from 'react';
import { Backdrop, Box, Typography, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';

const LoaderRing = ({ color }) => (
  <Box
    component="span"
    sx={{
      position: 'relative',
      width: 80,
      height: 80,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      '::before, ::after': {
        content: '""',
        position: 'absolute',
        inset: 0,
        borderRadius: '50%',
        borderWidth: 6,
        borderStyle: 'solid',
      },
      '::before': {
        borderColor: `${alpha(color, 0.25)}`,
      },
      '::after': {
        borderColor: `${color} transparent`,
        animation: 'loader-spin 1s linear infinite',
      },
      '@keyframes loader-spin': {
        '0%': { transform: 'rotate(0deg)' },
        '100%': { transform: 'rotate(360deg)' },
      },
    }}
  />
);

const PageLoader = ({
  loading = false,
  label = 'Loading data…',
  zIndex = (theme) => theme.zIndex.drawer + 1,
}) => {
  const theme = useTheme();
  const primary = theme.palette.primary.main;

  return (
    <Backdrop
      open={Boolean(loading)}
      sx={{
        zIndex,
        backdropFilter: 'blur(3px)',
        backgroundColor: alpha(theme.palette.background.default, 0.6),
      }}
    >
      <Box
        sx={{
          px: 4,
          py: 3,
          borderRadius: 3,
          bgcolor: alpha(theme.palette.background.paper, 0.85),
          boxShadow: `0 20px 40px ${alpha(theme.palette.common.black, 0.25)}`,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
          textAlign: 'center',
        }}
      >
        <LoaderRing color={primary} />
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: 600, color: theme.palette.text.primary }}
        >
          {label}
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: alpha(theme.palette.text.secondary, 0.9), maxWidth: 240 }}
        >
          Please hold on while we fetch the latest entries.
        </Typography>
      </Box>
    </Backdrop>
  );
};

export default PageLoader;

